import {
  Box,
  Grid,
  TextField,
  Divider,
  FormControl,
  FormHelperText,
  RadioGroup,
} from "@mui/material";

import FilterLabel from "./utils/FilterLabel";
import CustomSelectV2 from "../CustomSelectV2";
import RadioLabel from "./utils/RadioLabel";
import StyledRadio from "./utils/StyledRadio";
import FilterController from "./utils/FilterController";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadFieldNames, loadMessagesTypes } from "../../Swift/state/actions";
import { useKeycloak } from "@react-keycloak/web";

const messageDirections = [
  { id: "ALL", label: "All", value: "" },
  { id: "IN", label: "Incoming", value: "INCOMING" },
  { id: "OUT", label: "Outgoing", value: "OUTGOING" },
];

const messageTypeDefaultValue = { id: "ALL", name: "All" };
const fieldKeyDefaultValue = { id: "ALL", name: "All" };

const HeaderFilters = ({ values, errors, handleChange, setValues, Labels }) => {
  const dispatch = useDispatch();

  const fieldNames = [
    fieldKeyDefaultValue,
    ...useSelector((state) => state.swiftMessages.fieldNames.items),
  ];
  console.log("fieldNames", fieldNames);
  const messageTypesItems = useSelector(
    (state) => state.swiftMessages.messageTypes.items
  );

  const { keycloak } = useKeycloak();
  const allowedMT = keycloak.tokenParsed.allowedMT;

  const messageTypes =
    allowedMT?.length > 0
      ? [
          messageTypeDefaultValue,
          ...messageTypesItems.filter((item) => allowedMT.includes(item.name)),
        ]
      : [messageTypeDefaultValue, ...messageTypesItems];

  const getDirectionValue = () => {
    const value = messageDirections.find(
      (item) => item.value === values.direction
    );
    return value || messageDirections[0];
  };

  const getMessageTypeValue = () => {
    const value = messageTypes.find((item) => item.name === values.type);
    return value || messageTypeDefaultValue;
  };

  const getFieldKeyValue = () => {
    const value = fieldNames.find((item) => item.id === values.fieldkey);
    return value || fieldKeyDefaultValue;
  };

  const handleFieldNChange = (type) => {
    if (!!type && type !== messageTypeDefaultValue.name) {
      const messageType = messageTypes.find((item) => item.name === type);
      dispatch(loadFieldNames(messageType.id));
    } else {
      dispatch(loadFieldNames(""));
    }
  };

  useEffect(() => {
    dispatch(loadMessagesTypes());
  }, [dispatch]);

  return (
    <>
      <Grid item>
        <FormControl margin="dense" fullWidth>
          <FilterLabel>{Labels.headerTitle}</FilterLabel>
        </FormControl>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FilterController label={Labels.messageType} error={errors.type}>
              <CustomSelectV2
                label=""
                options={messageTypes}
                width="100%"
                background="#fff"
                isInvalid={!!errors.type}
                value={getMessageTypeValue()}
                onChange={(e, value) => {
                  setValues({ ...values, type: value.name });
                  handleFieldNChange(value.name);
                }}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disabled={messageTypes.length === 1}
              />
            </FilterController>
          </Grid>
          <Grid item xs={3}>
            <FilterController label="Way" error={errors.direction}>
              <CustomSelectV2
                label=""
                options={messageDirections}
                width="100%"
                background="#fff"
                isInvalid={!!errors.direction}
                value={getDirectionValue()}
                onChange={(e, value) => {
                  setValues({ ...values, direction: value.value });
                }}
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FilterController
              label="Session N&#176;"
              error={errors.sessionNumber}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.sessionNumber}
                value={values.sessionNumber || ""}
                onChange={handleChange}
                name="sessionNumber"
              />
            </FilterController>
          </Grid>
          <Grid item xs={3}>
            <FilterController
              label="Seq N&#176; range"
              error={
                errors.sequenceNumberFrom ||
                errors.sequenceNumberTo ||
                errors.sequenceFromTo
              }
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <TextField
                  type="number"
                  size="small"
                  placeholder="from"
                  sx={{ background: "#fff" }}
                  error={!!errors.sequenceNumberFrom || !!errors.sequenceFromTo}
                  value={values.sequenceNumberFrom}
                  onChange={handleChange}
                  name="sequenceNumberFrom"
                />
                <TextField
                  type="number"
                  size="small"
                  placeholder="to"
                  sx={{ background: "#fff" }}
                  error={!!errors.sequenceNumberTo || !!errors.sequenceFromTo}
                  value={values.sequenceNumberTo}
                  onChange={handleChange}
                  name="sequenceNumberTo"
                />
              </Box>
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <FilterController label="Message source" error={errors.source}>
          <RadioGroup
            row
            value={values.source}
            onChange={handleChange}
            name="source"
          >
            <RadioLabel value="ALL" control={<StyledRadio />} label="All" />
            <RadioLabel
              value="CORZAP"
              control={<StyledRadio />}
              label="Orchstro"
            />
            <RadioLabel
              value="SAA"
              control={<StyledRadio />}
              label="SWIFT Alliance Access (SAA)"
            />
          </RadioGroup>
        </FilterController>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FilterController
              label={Labels.field20}
              error={errors.f20ReferenceNumber}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f20ReferenceNumber}
                value={values.f20ReferenceNumber || ""}
                onChange={handleChange}
                name="f20ReferenceNumber"
              />
            </FilterController>
          </Grid>
          <Grid item xs={3}>
            <FilterController
              label="Related Reference Number"
              error={errors.f21ReferenceNumber}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f21ReferenceNumber}
                value={values.f21ReferenceNumber || ""}
                onChange={handleChange}
                name="f21ReferenceNumber"
              />
            </FilterController>
          </Grid>
          <Grid item xs={3}>
            <FilterController label={Labels.MUR} error={errors.f108Mur}>
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f108Mur}
                value={values.f108Mur || ""}
                onChange={handleChange}
                name="f108Mur"
              />
            </FilterController>
          </Grid>
          <Grid item xs={3}>
            <FilterController
              label="Clearance code"
              error={errors.clearanceCode}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.clearanceCode}
                value={values.clearanceCode || ""}
                onChange={handleChange}
                name="clearanceCode"
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <FilterController label={Labels.field} error={errors.fieldkey}>
              <CustomSelectV2
                label="Select"
                options={fieldNames}
                width="100%"
                background="#fff"
                isInvalid={!!errors.fieldkey}
                value={getFieldKeyValue()}
                onChange={(e, value) => {
                  setValues({ ...values, fieldkey: value.id });
                }}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disabled={fieldNames.length === 1 || values.type === "All"}
              />
            </FilterController>
          </Grid>
          <Grid item xs={4}>
            <FilterController label="Text message" error={errors.fieldValue}>
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.fieldValue}
                value={values.fieldValue || ""}
                onChange={handleChange}
                name="fieldValue"
              />
            </FilterController>
          </Grid>
        </Grid>
        <FormHelperText
          sx={{
            color: "var(--gray-2)",
            fontSize: 12,
            letterSpacing: "-0.4px",
            lineHeight: "14px",
          }}
        >
          Leave empty to search the whole message body
        </FormHelperText>
      </Grid>
      <Grid item>
        <Divider />
      </Grid>
    </>
  );
};

export default HeaderFilters;
